import {
  BOOKING_STATUS_LABELS,
  GATEWAY_STATE_LABELS,
  PAYMENT_STATUS_LABELS,
  WAITLIST_STATUS_LABELS,
  type GatewayState,
  type WaitlistStatus,
} from '../types';

const PILL = 'text-[11px] font-[600] px-2 py-0.5 rounded-full whitespace-nowrap';

const BOOKING_TONE: Record<string, string> = {
  PENDING_PAYMENT: 'bg-amber-100 text-amber-700',
  CONFIRMED: 'bg-emerald-100 text-emerald-700',
  SCHEDULED: 'bg-blue-100 text-blue-700',
  RESCHEDULED: 'bg-indigo-100 text-indigo-700',
  CANCELLED: 'bg-red-100 text-red-700',
  COMPLETED: 'bg-muted text-muted-foreground',
};

const PAYMENT_TONE: Record<string, string> = {
  UNPAID: 'bg-muted text-muted-foreground',
  DEPOSIT_PAID: 'bg-amber-100 text-amber-700',
  PAID: 'bg-emerald-100 text-emerald-700',
  REFUNDED: 'bg-red-100 text-red-700',
  PARTIALLY_REFUNDED: 'bg-orange-100 text-orange-700',
};

const GATEWAY_TONE: Record<GatewayState, string> = {
  open: 'bg-emerald-100 text-emerald-700',
  waitlist: 'bg-amber-100 text-amber-700',
  closed: 'bg-red-100 text-red-700',
};

const WAITLIST_TONE: Record<WaitlistStatus, string> = {
  WAITING: 'bg-amber-100 text-amber-700',
  CONTACTED: 'bg-blue-100 text-blue-700',
  CONVERTED: 'bg-emerald-100 text-emerald-700',
  CLOSED: 'bg-muted text-muted-foreground',
};

export function BookingStatusBadge({ status }: { status: string }) {
  const tone = BOOKING_TONE[status] ?? 'bg-muted text-muted-foreground';
  return <span className={`${PILL} ${tone}`}>{BOOKING_STATUS_LABELS[status] ?? status}</span>;
}

export function PaymentStatusBadge({ status }: { status?: string }) {
  if (!status) return <span className="text-muted-foreground">—</span>;
  const tone = PAYMENT_TONE[status] ?? 'bg-muted text-muted-foreground';
  return <span className={`${PILL} ${tone}`}>{PAYMENT_STATUS_LABELS[status] ?? status}</span>;
}

export function GatewayStateBadge({ state }: { state: GatewayState }) {
  return <span className={`${PILL} ${GATEWAY_TONE[state]}`}>{GATEWAY_STATE_LABELS[state]}</span>;
}

export function WaitlistStatusBadge({ status }: { status: WaitlistStatus }) {
  return <span className={`${PILL} ${WAITLIST_TONE[status]}`}>{WAITLIST_STATUS_LABELS[status]}</span>;
}

export function AddonSourceBadge({ source }: { source: string }) {
  const isAdmin = source === 'TCS_ADMIN';
  return (
    <span
      className={`${PILL} ${isAdmin ? 'bg-purple-100 text-purple-700' : 'bg-muted text-muted-foreground'}`}
    >
      {isAdmin ? 'TCS Admin' : 'Merchant'}
    </span>
  );
}
